<app-instance-info-section></app-instance-info-section>
<div class="row" style="width: 100%; margin: 10px 0px">
    <div class="col-md-4 user_number">
        <p>
            Users: <span>{{ userdetails?.length }}</span>
        </p>
    </div>
    <div class="col-md-8 text-end grid-list">
        <div class="search-wrapper">
            <mat-form-field style="width: auto; margin: 0px 15px">
                <input matInput type="text" placeholder="Enter a search item" [(ngModel)]="searchText" (keyup)="searchResult($event)" autocomplete="off" />
                <button mat-button matPrefix mat-icon-button class="search_btn">
                    <mat-icon class="serach_icon">search</mat-icon>
                </button>
            </mat-form-field>
            <button type="button" class="btn primary-ebtn me-5 ms-5" (click)="openUserModal()">Assign New User</button>
            <!-- <button (click)="openCustomModal();">DEMO MODAL</button> -->
            <div class="d-flex align-items-center">
                <a href="javascript:void(0)" (click)="div1Function()" matTooltip="Grid" [matTooltipPosition]="tooltip_position"
                    ><i class="fa fa-th-large" aria-hidden="true" [ngStyle]="{ color: div1 == true ? '#000' : '#696869' }"></i
                ></a>
                <a href="javascript:void(0)" (click)="div2Function()" matTooltip="List" [matTooltipPosition]="tooltip_position"
                    ><i class="fa fa-list" aria-hidden="true" [ngStyle]="{ color: div1 == false ? '#000' : '#696869' }"></i
                ></a>
            </div>
        </div>

        <ng-template #mymodal1 let-modal>
            <div class="modal-header">
                <h4>Add User</h4>
                <a class="close-icon" href="javascript:void()" ngbAutofocus><i class="flaticon2-cross"></i></a>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn primary-ebtn">Add</button>
                <button type="button" class="btn secondary-ebtn">Cancel</button>
            </div>
        </ng-template>
    </div>
</div>

<div class="row" style="width: 100%; margin: 10px 0px" *ngIf="roleKeys && div1; else listView">
    <div class="col-12" *ngFor="let role of roleKeys; let j = index" style="padding: 10px">
        <h4 class="mb-4 mt-4">{{ role }} :</h4>

        <div class="row d-flex justify-content-between">
            <div class="card-container d-flex justify-content-start" [ngClass]="j + 1 < roleKeys.length ? 'broder-bottom' : ''">
                <div class="user_card" *ngFor="let user of groupedUserdetails[role]; let i = index">
                    <mat-icon *ngIf="hideEditOption === false" class="mat-icon-view" (click)="viewUser(user)" #tooltip="matTooltip" matTooltip="view user">
                        remove_red_eye
                    </mat-icon>
                    <i
                        aria-hidden="true"
                        class="mdi mdi-account-minus mat-icon-delete"
                        style="font-size: 18px"
                        (click)="deleteInstanceUser(user)"
                        *ngIf="hideDeleteOption === true && role != 'Super Admin'"
                        #tooltip="matTooltip"
                        matTooltip="Remove user"
                    ></i>

                    <div class="user_img">
                        <!-- <ngx-avatars
                            name="{{ user?.firstName }}  {{ user?.lastName }}"
                            initialsSize="3"
                            [round]="true"
                            [size]="avatarSize"
                            bgColor="#ffcc01"
                            fgColor="#3F4254"
                        >
                        </ngx-avatars> -->
                        <div
                            class="custom-avatar"
                            [ngStyle]="{
                                width: avatarSize + 'px',
                                height: avatarSize + 'px',
                                backgroundColor: '#ffcc01',
                                color: '#3F4254',
                                fontSize: avatarSize / 3 + 'px',
                                borderRadius: '50%',
                            }"
                        >
                            {{ getInitials((user?.firstName || '') + ' ' + (user?.lastName || '')) }}
                        </div>
                    </div>
                    <div class="user_details">
                        <div>
                            <h3 matTooltip="{{ user?.firstName?.length > 13 ? user?.firstName : null }}">
                                {{ user?.firstName }}
                            </h3>
                        </div>
                        <div>
                            <h3 matTooltip="{{ user?.lastName?.length > 13 ? user?.lastName : null }}">
                                {{ user?.lastName }}
                            </h3>
                        </div>
                        <div *ngIf="user?.email">
                            <p
                                class="email-wrap"
                                (mouseenter)="manageHover(0)"
                                (mouseout)="manageHover(1)"
                                matTooltip="{{ user?.email?.length > 23 ? user?.email : null }}"
                            >
                                {{ user?.email }}
                            </p>
                        </div>
                        <!-- <div class="user-email">
                            <p class="email-wrap" (mouseenter)="manageHover(0)" (mouseout)="manageHover(1)"
                                matTooltip="{{ user?.email?.length > 23 ? user?.email : null }}">
                                {{ user?.email }}
                            </p>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #listView>
    <div class="row" style="width: 100%; margin: 0 auto">
        <div class="col-12" *ngFor="let role of roleKeys; let j = index">
            <h4 class="mb-4 mt-4">{{ role }} :</h4>
            <div class="row">
                <div class="col-12" [ngClass]="i + 1 < roleKeys.length ? 'broder-bottom' : ''">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-12 col-12" *ngFor="let user of groupedUserdetails[role]; let i = index">
                            <div class="mb-5">
                                <div class="user_card-list">
                                    <div class="user_img" *ngIf="!user.image; else user_profile_image">
                                        <!-- <ngx-avatars name="{{ user.firstName }} {{ user.lastName }} {{ i }}"
                                            initialsSize="3" [round]="true" [size]="avatarSize" bgColor="#ffcc01"
                                            fgColor="#010101">
                                        </ngx-avatars> -->
                                        <div
                                            class="custom-avatar"
                                            [ngStyle]="{
                                                width: avatarSize + 'px',
                                                height: avatarSize + 'px',
                                                backgroundColor: '#ffcc01',
                                                color: '#010101',
                                                fontSize: avatarSize / 3 + 'px',
                                                borderRadius: '50%',
                                            }"
                                        >
                                            {{ getInitials(user.firstName + ' ' + user.lastName + ' ' + i) }}
                                        </div>
                                    </div>
                                    <div class="userlistdetail">
                                        <div class="details">
                                            <div [matTooltipDisabled]="!checkIsTextOverflow('firstName', user?.userId)" matTooltip="{{ user?.firstName }}">
                                                <h4 id="{{ user?.userId }}-first-name">{{ user?.firstName }}</h4>
                                            </div>
                                            <div [matTooltipDisabled]="!checkIsTextOverflow('lastName', user?.userId)" matTooltip="{{ user?.lastName }}">
                                                <h4 id="{{ user?.userId }}-last-name">
                                                    {{ user?.lastName }}
                                                </h4>
                                            </div>
                                            <!-- <p id="{{ user?.userId }}-role"
                                                [matTooltipDisabled]="!checkIsTextOverflow('role', user?.userId)"
                                                matTooltip="{{ user.securityRole }}">
                                                {{ user.securityRole }}&nbsp;
                                            </p> -->
                                            <p
                                                [matTooltipDisabled]="!checkIsTextOverflow('email', user?.userId)"
                                                matTooltip="{{ user?.email }}"
                                                id="{{ user.userId }}-email"
                                                class="email-wrap"
                                                (mouseenter)="manageHover(0)"
                                                (mouseout)="manageHover(1)"
                                            >
                                                {{ user?.email }}
                                            </p>
                                            <div class="action-icons">
                                                <mat-icon
                                                    #tooltip="matTooltip"
                                                    matTooltip="View"
                                                    *ngIf="hideEditOption === false"
                                                    class="mat-icon-view"
                                                    (click)="viewUser(user)"
                                                    [matTooltipPosition]="tooltip_position"
                                                    [ngStyle]="{ top: role == 'Super Admin' ? '25px' : '12px' }"
                                                >
                                                    remove_red_eye
                                                </mat-icon>
                                                <i
                                                    aria-hidden="true"
                                                    class="mdi mdi-account-minus mat-icon-delete"
                                                    style="font-size: 18px"
                                                    (click)="deleteInstanceUser(user)"
                                                    *ngIf="hideDeleteOption === true && role != 'Super Admin'"
                                                    #tooltip="matTooltip"
                                                    [matTooltipPosition]="tooltip_position"
                                                    matTooltip="Remove user"
                                                ></i>
                                                <!-- <mat-icon #tooltip="matTooltip" class="mat-icon-delete"
                                                    matTooltip="Delete" *ngIf="hideDeleteOption === true"
                                                    [matTooltipPosition]="tooltip_position" (click)="deleteUser(user)">
                                                    delete
                                                </mat-icon> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-6"></div>
    </div>
</ng-template>

<div class="row mt-10" style="margin: 0 auto">
    <div class="col-md-12 text-end">
        <button type="button" class="btn primary-ebtn me-3" (click)="navigateBack()">           
       
         <div class="d-flex align-items-center gap-1">
                                        <span class="svg-icon-primary svg-icon-2x">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px"
                                                viewBox="0 0 24 24" version="1.1">
                                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <polygon points="0 0 24 0 24 24 0 24" />
                                                     <rect fill="#000000" opacity="0.3"
                                                        transform="translate(15.000000, 12.000000) rotate(90.000000) translate(-15.000000, -12.000000)"
                                                        x="11" y="4.5" width="2" height="9" rx="1" />
                                                    
                                                    <path
                                                        d="M14.2929,15.7071 C13.9024,16.0976 13.2692,16.0976 12.8787,15.7071 
                                                                                                                                           L6.87868,9.70711 C6.48816,9.31658 6.48816,8.68342 6.87868,8.29289 
                                                                                                                                           L12.8787,2.29289 C13.2692,1.90237 13.9024,1.90237 14.2929,2.29289 
                                                                                                                                           C14.6834,2.68342 14.6834,3.31658 14.2929,3.70711 
                                                                                                                                           L9.58579,8.41421 L14.2929,13.1213 
                                                                                                                                           C14.6834,13.5118 14.6834,14.145 14.2929,14.5355 Z"
                                                        fill="#000000" fill-rule="nonzero" />
                                                </g>
                                            </svg>
                                        </span>
                                        Back
                                    </div>
        </button>
        <button href="javascript:void()" type="button" class="btn secondary-ebtn me-3" (click)="clickCancel()">Cancel</button>
        <button type="button" class="btn primary-ebtn" (click)="navigateNext()">
          
 <div class="d-flex align-items-center gap-1">
                                      Next
                                        <span   class="svg-icon-primary svg-icon-2x"><svg
                                                class="d-flex" xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink" width="18px" height="18px"
                                                viewBox="0 0 24 24" version="1.1">
                                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <polygon points="0 0 24 0 24 24 0 24" />
                                                    <rect fill="#000000" opacity="0.3"
                                                        transform="translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000) "
                                                        x="7.5" y="7.5" width="2" height="9" rx="1" />
                                                    <path
                                                        d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                                        fill="#000000" fill-rule="nonzero"
                                                        transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997) " />
                                                </g>
                                            </svg>
                                        </span>
                                    </div>


        </button>
    </div>
</div>
